import { Box, useTheme } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { Button } from '@mui/material'
import { tokens } from '../../theme'
import Header from '../../components/Header'
import React from "react"
import { useState, useEffect } from "react"
import { ptBR as ptBRGrid } from '@mui/x-data-grid'
import { useNavigate } from 'react-router-dom'
import * as Constants from '../../constants'

const Livestreams = () => {
  const theme = useTheme()
  const colors = tokens(theme.palette.mode)

  const [rows, setRows] = useState([])

  const fetchLivestreams = () => {
    fetch(Constants.HOST + '/livestreams', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        token: JSON.parse(localStorage.getItem('user_data')).token,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          response.json().then((data) => {
            data = data.data
            let newRows = []

            if (typeof data.livestreams === 'object') {
              data.livestreams.forEach((livestream) => {
                newRows.push({
                  id: livestream.id,
                  title: livestream.title,
                  description: livestream.description,
                  datetime: livestream.time_to_notify,
                  url: livestream.livestream_url,
                  owners: livestream.owners_string,
                  created_by: livestream.created_by,
                })
              })
            }

            setRows(newRows)
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  useEffect(() => {
    fetchLivestreams()
  }, [])

  const columns = [
    {
      field: 'title',
      headerName: 'Título',
      flex: 2,
      cellClassName: 'name-column--cell',
    },
    { field: 'description', headerName: 'Descrição', flex: 2 },
    { field: 'datetime', headerName: 'Agendamento', flex: 1 },
    { field: 'owners', headerName: 'Proprietários', flex: 1 },
    { field: 'url', headerName: 'URL', flex: 1 },
    {
      field: 'actions',
      headerName: 'Gerenciar',
      flex: 1,
      renderCell: ({ row: { id } }) => {
        return (
          <Box justifyContent="right" sx={{ flexGrow: 1, display: 'flex' }}>
            <Button
              variant="contained"
              onClick={() => navigate(`/del-livestream/${id}`)}
            >
              {' '}
              Excluir{' '}
            </Button>
          </Box>
        )
      },
    },
  ]

  let navigate = useNavigate()
  const handleAddLivestream = () => {
    navigate('/add-livestream')
  }

  return (
    <Box m="20px">
      <Box mb="20px" display="flex" justifyContent="space-between">
        <Box display="grid" gridColumn="span 6" justifyContent="space-between">
          <Header
            title="Livestreams"
            subtitle="Gerencie o envio de notificações para transmissões futuras."
          />
        </Box>
        <Box m="20px 0" gridColumn="span 6" justifyContent="flex-end">
          <Button
            variant="contained"
            color="warning"
            onClick={handleAddLivestream}
            sx={{ mr: '5px' }}
          >
            Agendar nova livestream
          </Button>
        </Box>
      </Box>
      <Box
        m="20px 0 0 0"
        height="75vh"
        sx={{
          '& .MuiDataGrid-root': {
            border: 'none',
          },
          '& .MuiDataGrid-cell': {
            borderBottom: 'none',
          },
          '& .name-column--cell': {
            color: colors.greenAccent[300],
          },
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: colors.blueAccent[700],
            borderBottom: 'none',
          },
          '& .MuiDataGrid-virtualScroller': {
            backgroundColor: colors.primary[400],
          },
          '& .MuiDataGrid-footerContainer': {
            borderTop: 'none',
            backgroundColor: colors.blueAccent[700],
          },
          '& .MuiCheckbox-root': {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          localeText={ptBRGrid.components.MuiDataGrid.defaultProps.localeText}
          initialState={{
            sorting: {
              sortModel: [{ field: 'datetime', sort: 'desc' }],
            },
          }}
        />
      </Box>
    </Box>
  )
}

export default Livestreams
